// const { decodeEntities } = wp.htmlEntities;
// const { getSetting } = wc.wcSettings;
// const { registerPaymentMethod } = wc.wcBlocksRegistry;
// const { useEffect } = wp.element;
// // import { loadStripe } from '@stripe/stripe-js';
//
// // Data
// const settings = getSetting('bikepot_stripe_data', {});
//
// const title = decodeEntities(settings.title || '');
// const iconUrl = settings.iconurl;
// const available = decodeEntities(settings.available || false);
// const fields = decodeEntities(settings.fields || '');
//
// const canMakePayment = () => {
//     return available;
// };
//
// const Content = props => {
//     const { eventRegistration, emitResponse } = props;
//     const { onPaymentProcessing } = eventRegistration;
//     useEffect( () => {
//         const unsubscribe = onPaymentProcessing( async () => {
//             const blikInput = document.querySelector('#paynow_blik_code');
//             const blikCode = blikInput ? blikInput.value : false;
//
//             if ( !blikInput ) {
//                 return {
//                     type: emitResponse.responseTypes.SUCCESS,
//                 };
//             }
//
//             if ( blikInput && blikCode ) {
//                 return {
//                     type: emitResponse.responseTypes.SUCCESS,
//                     meta: {
//                         paymentMethodData: {
//                             'authorizationCode': blikCode,
//                         },
//                     },
//                 };
//             }
//
//             return {
//                 type: emitResponse.responseTypes.ERROR,
//                 message: 'BLIK Code does not exists',
//             };
//         } );
//         return () => {
//             unsubscribe();
//         };
//     }, [
//         emitResponse.responseTypes.ERROR,
//         emitResponse.responseTypes.SUCCESS,
//         onPaymentProcessing,
//     ] );
//     return <div dangerouslySetInnerHTML={{__html: fields}}></div>;
// };
//
// const Label = props => {
//     const { PaymentMethodLabel } = props.components;
//     const icon = <img src={iconUrl} alt={title} name={title} />
//     return <PaymentMethodLabel className='bikepot-stripe-payment-label' text={title} icon={icon} />;
// };
//
// /**
//  * Bikepot Stripe Payment method config.
//  */
// const BikepotStripePaymentOptions = {
//     name: 'bikepot_stripe_payment',
//     label: <Label />,
//     content: <Content />,
//     edit: <Content />,
//     canMakePayment: canMakePayment,
//     ariaLabel: title
// };
//
// registerPaymentMethod(BikepotStripePaymentOptions);
